import NProgress from 'nprogress';
import './nprogress.module.scss';

export default {
  start: () => NProgress.start(),
  done: () => NProgress.done(),
};
